const page = document.querySelector('.product-page');
const bar = page?.querySelector('[data-product-sticky]');
const summary = page?.querySelector('.product-page__summary');
const tabs = page?.querySelector('.product-page__info .tabs');
const header = document.querySelector('.header');

if (page && bar && summary) {
    const action = bar.querySelector('[data-product-sticky-action]');
    const actionLabel = action.querySelector('[data-product-sticky-action-label]');
    const originalButtons = summary.querySelector('.product-page__buttons');
    const tabNav = bar.querySelector('[data-product-sticky-tabs]');
    const tabButtons = tabs ? Array.from(tabs.querySelectorAll('.tabs__nav [data-product-sticky-tab]')) : [];

    tabButtons.forEach((original) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = original.textContent.trim();
        button.addEventListener('click', () => {
            original.click();
            const top = window.scrollY + tabs.getBoundingClientRect().top - bar.offsetHeight - 12;
            window.scrollTo({top: Math.max(top, 0), behavior: 'smooth'});
        });
        tabNav.appendChild(button);
    });

    const syncAction = () => {
        const cartButton = originalButtons?.querySelector('button.add-to-cart');
        const cartLink = originalButtons?.querySelector('a.already-in-cart:not(.hidden)');
        const requestButton = originalButtons?.querySelector('#showRequestForm');
        const target = cartButton || cartLink || requestButton;
        actionLabel.textContent = cartButton ? 'В корзину' : cartLink ? 'В корзине' : 'Оставить заявку';
        action.classList.toggle('_in-cart', !!cartLink && !cartButton);
        action.classList.toggle('_request', !cartButton && !cartLink);
        action.querySelector('.product-sticky__action-icon')?.remove();
        const icon = target?.querySelector('svg')?.cloneNode(true);
        if (icon) {
            icon.classList.add('product-sticky__action-icon');
            icon.setAttribute('aria-hidden', 'true');
            action.prepend(icon);
        }
        action.disabled = !target;
    };

    action.addEventListener('click', () => {
        const target = originalButtons?.querySelector('button.add-to-cart')
            || originalButtons?.querySelector('a.already-in-cart:not(.hidden)')
            || originalButtons?.querySelector('#showRequestForm');
        target?.click();
    });
    if (originalButtons) {
        new MutationObserver(syncAction).observe(originalButtons, {attributes: true, childList: true, subtree: true});
    }
    syncAction();

    let scheduled = false;
    const updateVisibility = () => {
        scheduled = false;
        const headerHeight = header?.getBoundingClientRect().height || 0;
        bar.hidden = summary.getBoundingClientRect().bottom > headerHeight;
        header?.classList.toggle('_product-sticky-hidden', !bar.hidden);
    };
    const scheduleUpdate = () => {
        if (!scheduled) {
            scheduled = true;
            requestAnimationFrame(updateVisibility);
        }
    };
    window.addEventListener('scroll', scheduleUpdate, {passive: true});
    window.addEventListener('resize', scheduleUpdate);
    updateVisibility();
}
